/* VitalSense product page: follow Weglot's language without Weglot.
   Weglot on this store translates in the browser, on the English URL, and
   only words it has credits for, so a new page stays English when the
   credits run out. The page carries its own copy in each language
   (snippets/vitalsense-pdp-i18n.liquid) and swaps it here whenever Weglot's
   language changes. Without Weglot, the server's language (the /es or /fr
   URL) already rendered the right text and nothing is swapped. */
(function () {
  var data;
  try { data = JSON.parse(document.getElementById('vs-pdp-i18n').textContent); } catch (e) { return; }
  var script = document.currentScript;
  var serverLang = ((script && script.getAttribute('data-server-lang')) || document.documentElement.lang || 'en').slice(0, 2);

  function apply(lang) {
    var t = data[(lang || '').slice(0, 2)] || data[serverLang] || data.en;
    document.querySelectorAll('[data-vs]').forEach(function (el) { var v = t[el.getAttribute('data-vs')]; if (v != null) el.textContent = v; });
    document.querySelectorAll('[data-vs-html]').forEach(function (el) { var v = t[el.getAttribute('data-vs-html')]; if (v != null) el.innerHTML = v; });
    document.querySelectorAll('[data-vs-alt]').forEach(function (el) { var v = t[el.getAttribute('data-vs-alt')]; if (v != null) el.setAttribute('alt', v); });
  }
  function weglotLang() {
    try { return window.Weglot && Weglot.getCurrentLang ? Weglot.getCurrentLang() : null; } catch (e) { return null; }
  }
  function hook() {
    var lang = weglotLang();
    if (lang) apply(lang);
    try {
      Weglot.on('languageChanged', function (newLang) { apply(newLang); });
      Weglot.on('initialized', function () { apply(weglotLang()); });
    } catch (e) {}
  }
  // Weglot loads on its own schedule; wait for it up to 10 seconds.
  if (window.Weglot && Weglot.on) { hook(); return; }
  var tries = 0;
  var wait = setInterval(function () {
    if (window.Weglot && Weglot.on) { clearInterval(wait); hook(); }
    else if (++tries > 40) clearInterval(wait);
  }, 250);
})();
